import { render } from "./InfoBackgroundModule.vue?vue&type=template&id=172bad89&scoped=true"
import script from "./InfoBackgroundModule.vue?vue&type=script&lang=js"
export * from "./InfoBackgroundModule.vue?vue&type=script&lang=js"

import "./InfoBackgroundModule.vue?vue&type=style&index=0&id=172bad89&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172bad89"]])

export default __exports__